import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardHeaderBtn,
  CardBody,
} from "./../../components/card/card.jsx";

function CreateDetail() {
  const [step, setStep] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedVehicle, setSelectedVehicle] = useState({
    brand: "",
    model: "",
    year: "",
    version: "",
  });
  const [availableModels, setAvailableModels] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableVersions, setAvailableVersions] = useState([]);
  const [vehiclePrice, setVehiclePrice] = useState(0);

  const [financingMonths, setFinancingMonths] = useState(12);
  const [downPaymentPercentage, setDownPaymentPercentage] = useState(10);

  const handleNextStep = () => setStep(step + 1);
  const handlePreviousStep = () => setStep(step - 1);

  const plans = [
    {
      title: "Cobertura de llantas",
      status: "Nuevo",
      price: "$6,896.00",
    },
    {
      title: "Cobertura de llaves",
      status: "Nuevo",
      price: "$7,200.00",
    },
    {
      title: "Cobertura amplia",
      status: "Nuevo",
      price: "$8,000.00",
    },
    {
      title: "Tren motriz",
      status: "Nuevo",
      price: "$6,896.00",
    },
    {
      title: "Garantía de movilidad",
      status: "Nuevo",
      price: "$7,200.00",
    },
    {
      title: "GPS",
      status: "Nuevo",
      price: "$8,000.00",
    },
    {
      title: "Garantía extendida",
      status: "Nuevo",
      price: "$8,000.00",
    },
  ];

  const vehicleData = {
    Toyota: {
      Corolla: {
        2020: [
          { version: "Base", price: 250000 },
          { version: "LE", price: 270000 },
          { version: "XLE", price: 300000 },
        ],
        2021: [
          { version: "Base", price: 260000 },
          { version: "LE", price: 280000 },
          { version: "XLE", price: 310000 },
        ],
      },
      Camry: {
        2020: [
          { version: "SE", price: 350000 },
          { version: "XSE", price: 370000 },
        ],
        2021: [
          { version: "SE", price: 360000 },
          { version: "XSE", price: 380000 },
          { version: "LE", price: 340000 },
        ],
      },
    },
    Honda: {
      Civic: {
        2020: [
          { version: "LX", price: 230000 },
          { version: "Sport", price: 250000 },
        ],
        2021: [
          { version: "LX", price: 240000 },
          { version: "Sport", price: 260000 },
          { version: "EX", price: 280000 },
        ],
      },
      Accord: {
        2020: [
          { version: "EX", price: 330000 },
          { version: "Touring", price: 350000 },
        ],
        2021: [
          { version: "EX", price: 340000 },
          { version: "Touring", price: 360000 },
          { version: "LX", price: 320000 },
        ],
      },
    },
  };

  const handleBrandChange = (e) => {
    const selectedBrand = e.target.value;
    setSelectedVehicle({
      brand: selectedBrand,
      model: "",
      year: "",
      version: "",
    });
    setAvailableModels(Object.keys(vehicleData[selectedBrand] || {}));
    setAvailableYears([]);
    setAvailableVersions([]);
    setVehiclePrice(0);
  };

  const handleModelChange = (e) => {
    const selectedModel = e.target.value;
    setSelectedVehicle((prevState) => ({
      ...prevState,
      model: selectedModel,
      year: "",
      version: "",
    }));
    setAvailableYears(
      Object.keys(vehicleData[selectedVehicle.brand][selectedModel] || {})
    );
    setAvailableVersions([]);
    setVehiclePrice(0);
  };

  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    setSelectedVehicle((prevState) => ({
      ...prevState,
      year: selectedYear,
      version: "",
    }));
    setAvailableVersions(
      vehicleData[selectedVehicle.brand][selectedVehicle.model][selectedYear] ||
        []
    );
    setVehiclePrice(0);
  };

  const handleVersionChange = (e) => {
    const selectedVersion = e.target.value;
    const selectedVersionData = vehicleData[selectedVehicle.brand][
      selectedVehicle.model
    ][selectedVehicle.year].find((v) => v.version === selectedVersion);
    setSelectedVehicle((prevState) => ({
      ...prevState,
      version: selectedVersion,
    }));
    setVehiclePrice(selectedVersionData ? selectedVersionData.price : 0);
  };

  const calculateMonthlyPayment = () => {
    if (vehiclePrice > 0) {
      const downPayment = (downPaymentPercentage / 100) * vehiclePrice;
      const financedAmount = vehiclePrice - downPayment;
      const monthlyPayment = financedAmount / financingMonths;
      return monthlyPayment.toFixed(2);
    }
    return 0;
  };

  const [cliente, setCliente] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    codigoPostal: "",
    correo: "",
    comentario: "",
    motivoRechazo: "",
  });

  const [condicionVehiculo, setCondicionVehiculo] = useState("");

  const handleCondicionChange = (e) => {
    setCondicionVehiculo(e.target.value);
  };

  const handleClienteChange = (e) => {
    const { id, value } = e.target;
    setCliente((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleRegisterVehicle = async () => {
    const accessToken = "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
    const apiUrl = "https://api.checkmark.mx/vehiculos/register";

    setIsSubmitting(true); // Bloquea temporalmente el botón

    // Datos del formulario
    const requestData = {
      access_token: accessToken,
      nombre: cliente.nombre,
      apellido: cliente.apellido,
      telefono: cliente.telefono,
      codigo_postal: cliente.codigoPostal,
      correo: cliente.correo,
      comentario: cliente.comentario,
      motivo_rechazo: cliente.motivoRechazo,
      marca: selectedVehicle.brand,
      modelo: selectedVehicle.model,
      anio: selectedVehicle.year,
      version: selectedVehicle.version,
      condicion: condicionVehiculo,
      precio_total: vehiclePrice,
      financiamiento_meses: financingMonths,
      enganche_porcentaje: downPaymentPercentage,
      mensualidad_estimada: calculateMonthlyPayment(),
      plan_accesorios: selectedPlan !== null ? plans[selectedPlan] : null,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      // Manejo basado en el statusCode
      switch (result.statusCode) {
        case 200:
          alert(`¡Registro exitoso! ${result.data.description}`);
          setIsSubmitted(true); // Bloquea todo el formulario
          break;

        case 405:
          alert(`${result.error.description}`);
          break;

        case 401:
          alert(`${result.error.description}`);
          break;

        default:
          alert(
            `Error desconocido (${result.statusCode}): ${
              result.error?.description || "Sin descripción."
            }`
          );
          break;
      }
    } catch (error) {
      console.error("Error al conectar con la API:", error);
      alert("Hubo un error al procesar la solicitud. Inténtalo más tarde.");
    } finally {
      setIsSubmitting(false); // Detiene el estado de envío
    }
  };

  return (
    <div className="mailbox">
      <div className="mailbox-toolbar">
        <div className="mailbox-toolbar-item">
          <span className="mailbox-toolbar-text">Deals</span>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/detail" className="mailbox-toolbar-link">
            Clientes
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/create" className="mailbox-toolbar-link active">
            Entrevista
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/analytics" className="mailbox-toolbar-link">
            Analítica
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/tools" className="mailbox-toolbar-link">
            Tools
          </Link>
        </div>
        <div className="mailbox-toolbar-item">
          <Link to="/deals/contract" className="mailbox-toolbar-link">
            Contrato
          </Link>
        </div>
      </div>
      {/* <div className="mailbox-body">
        <div className="mailbox-content">
          <PerfectScrollbar className="h-100"> */}

            <div className="mailbox-detail">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-12">
                    <div className="row">
                      <div className="col-xl-12">
                        <div id="wizardLayout1" className="mb-5">
                          <h4>DEALS</h4>
                          <Card>
                            <CardHeader className="with-btn">
                              FINANCIAMIENTO
                              <CardHeaderBtn />
                            </CardHeader>
                            <CardBody>
                              <div className="nav-wizards-container">
                                <nav className="nav nav-wizards-3 mb-2">
                                  <div className="nav-item col">
                                    <a
                                      className={`nav-link ${
                                        step >= 1 ? "completed" : ""
                                      } ${step === 1 ? "active" : ""}`}
                                      href="#/"
                                    >
                                      <div className="nav-dot"></div>
                                      <div className="nav-title">1</div>
                                      <div className="nav-text">Cliente</div>
                                    </a>
                                  </div>

                                  <div className="nav-item col">
                                    <a
                                      className={`nav-link ${
                                        step >= 2 ? "completed" : ""
                                      } ${step === 2 ? "active" : ""}`}
                                      href="#/"
                                    >
                                      <div className="nav-dot"></div>
                                      <div className="nav-title">2</div>
                                      <div className="nav-text">Auto</div>
                                    </a>
                                  </div>

                                  <div className="nav-item col">
                                    <a
                                      className={`nav-link ${
                                        step >= 3 ? "completed" : ""
                                      } ${step === 3 ? "active" : ""}`}
                                      href="#/"
                                    >
                                      <div className="nav-dot"></div>
                                      <div className="nav-title">3</div>
                                      <div className="nav-text">
                                        Financiamiento
                                      </div>
                                    </a>
                                  </div>

                                  <div className="nav-item col">
                                    <a
                                      className={`nav-link ${
                                        step >= 4 ? "completed" : ""
                                      } ${step === 4 ? "active" : ""}`}
                                      href="#/"
                                    >
                                      <div className="nav-dot"></div>
                                      <div className="nav-title">4</div>
                                      <div className="nav-text">Accesorios</div>
                                    </a>
                                  </div>
                                </nav>
                              </div>

                              <Card>
                                <CardBody>
                                  {step === 1 && (
                                    <div>
                                      <h5>Cliente</h5>
                                      {/* Fila para Nombre y Apellido */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Nombre</label>
                                          <input
                                            id="nombre"
                                            type="text"
                                            className="form-control"
                                            placeholder="Nombre"
                                            value={cliente.nombre}
                                            onChange={handleClienteChange}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Apellido</label>
                                          <input
                                            id="apellido"
                                            type="text"
                                            className="form-control"
                                            placeholder="Apellido"
                                            value={cliente.apellido}
                                            onChange={handleClienteChange}
                                          />
                                        </div>
                                      </div>

                                      {/* Fila para Número de teléfono y Código postal */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Número de teléfono</label>
                                          <input
                                            id="telefono"
                                            type="number"
                                            className="form-control"
                                            placeholder="Teléfono"
                                            value={cliente.telefono}
                                            onChange={handleClienteChange}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Código postal</label>
                                          <input
                                            id="codigoPostal"
                                            type="number"
                                            className="form-control"
                                            placeholder="Código postal"
                                            value={cliente.codigoPostal}
                                            onChange={handleClienteChange}
                                          />
                                        </div>
                                      </div>

                                      {/* Fila para Correo electrónico y Motivo de rechazo */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Correo electrónico</label>
                                          <input
                                            id="correo"
                                            type="email"
                                            className="form-control"
                                            placeholder="Correo"
                                            value={cliente.correo}
                                            onChange={handleClienteChange}
                                          />
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Motivo de rechazo</label>
                                          <select
                                            id="motivoRechazo"
                                            className="form-control custom-select"
                                            value={cliente.motivoRechazo}
                                            onChange={handleClienteChange}
                                          >
                                            <option value="">
                                              Seleccione motivo
                                            </option>
                                            <option value="Por score">
                                              Por score
                                            </option>
                                            <option value="Por buró">
                                              Por buró
                                            </option>
                                            <option value="Por edad">
                                              Por edad
                                            </option>
                                            <option value="Por ingreso">
                                              Por ingreso
                                            </option>
                                            <option value="Otro">Otro</option>
                                          </select>
                                        </div>
                                      </div>

                                      {/* Campo de Comentario (ocupa toda la fila) */}
                                      <div className="row mb-3">
                                        <div className="col-lg-12">
                                          <label>Comentario</label>
                                          <textarea
                                            id="comentario"
                                            className="form-control"
                                            rows="3"
                                            value={cliente.comentario}
                                            onChange={handleClienteChange}
                                          ></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {step === 2 && (
                                    <div>
                                      <h5>Auto</h5>

                                      {/* Fila para Marca y Modelo */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Marca</label>
                                          <select
                                            id="marcaVehiculo"
                                            className="form-control custom-select"
                                            value={selectedVehicle.brand}
                                            onChange={handleBrandChange}
                                          >
                                            <option value="">
                                              Seleccione marca
                                            </option>
                                            {Object.keys(vehicleData).map(
                                              (brand) => (
                                                <option
                                                  key={brand}
                                                  value={brand}
                                                >
                                                  {brand}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Modelo</label>
                                          <select
                                            id="modeloVehiculo"
                                            className="form-control custom-select"
                                            value={selectedVehicle.model}
                                            onChange={handleModelChange}
                                            disabled={!availableModels.length}
                                          >
                                            <option value="">
                                              Seleccione modelo
                                            </option>
                                            {availableModels.map((model) => (
                                              <option key={model} value={model}>
                                                {model}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>

                                      {/* Fila para Año y Versión */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Año</label>
                                          <select
                                            id="añoVehiculo"
                                            className="form-control custom-select"
                                            value={selectedVehicle.year}
                                            onChange={handleYearChange}
                                            disabled={!availableYears.length}
                                          >
                                            <option value="">
                                              Seleccione año
                                            </option>
                                            {availableYears.map((year) => (
                                              <option key={year} value={year}>
                                                {year}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Versión</label>
                                          <select
                                            id="versionVehiculo"
                                            className="form-control custom-select"
                                            value={selectedVehicle.version}
                                            onChange={handleVersionChange}
                                            disabled={!availableVersions.length}
                                          >
                                            <option value="">
                                              Seleccione versión
                                            </option>
                                            {availableVersions.map(
                                              ({ version }) => (
                                                <option
                                                  key={version}
                                                  value={version}
                                                >
                                                  {version}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>

                                      {/* Fila para Condición y Precio Total */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label>Condición</label>
                                          <select
                                            id="condicionVehiculo"
                                            className="form-control custom-select"
                                            value={condicionVehiculo}
                                            onChange={handleCondicionChange}
                                          >
                                            <option value="">
                                              Seleccione condición
                                            </option>
                                            <option value="Nuevo">Nuevo</option>
                                            <option value="Seminuevo">
                                              Seminuevo
                                            </option>
                                          </select>
                                        </div>
                                        <div className="col-lg-6">
                                          <label>Precio Total</label>
                                          <input
                                            id="precioTotalVehiculo"
                                            type="text"
                                            className="form-control"
                                            value={
                                              vehiclePrice
                                                ? `$${vehiclePrice}`
                                                : ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {step === 3 && (
                                    <div id="wizardLayout1" className="mb-5">
                                      <h4>Financiamiento</h4>

                                      {/* Fila para Meses de Financiamiento y Porcentaje de Enganche */}
                                      <div className="row mb-3">
                                        <div className="col-lg-6">
                                          <label htmlFor="financingMonths">
                                            Meses de Financiamiento:
                                          </label>
                                          <select
                                            id="financingMonths"
                                            className="form-control custom-select"
                                            value={financingMonths}
                                            onChange={(e) =>
                                              setFinancingMonths(
                                                Number(e.target.value)
                                              )
                                            }
                                          >
                                            <option value={12}>12 meses</option>
                                            <option value={24}>24 meses</option>
                                            <option value={36}>36 meses</option>
                                            <option value={48}>48 meses</option>
                                            <option value={60}>60 meses</option>
                                          </select>
                                        </div>
                                        <div className="col-lg-6">
                                          <label htmlFor="downPaymentPercentage">
                                            Porcentaje de Enganche:
                                          </label>
                                          <input
                                            id="downPaymentPercentage"
                                            type="range"
                                            className="form-range"
                                            min="0"
                                            max="100"
                                            value={downPaymentPercentage}
                                            onChange={(e) =>
                                              setDownPaymentPercentage(
                                                Number(e.target.value)
                                              )
                                            }
                                          />
                                          <span>{downPaymentPercentage}%</span>
                                        </div>
                                      </div>

                                      {/* Fila para la Mensualidad Estimada */}
                                      <div className="row">
                                        <div className="col-lg-12">
                                          <h5>
                                            Mensualidad Estimada: $
                                            {calculateMonthlyPayment()}
                                          </h5>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {step === 4 && (
                                    <div>
                                      <h5>Accesorios</h5>
                                      <div className="row">
                                        {plans.map((plan, index) => (
                                          <div
                                            className="col-md-4 mb-4"
                                            key={index}
                                          >
                                            <div
                                              className={`card ${
                                                selectedPlan === index
                                                  ? "border-primary"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                setSelectedPlan(index)
                                              }
                                            >
                                              <div className="card-body text-center">
                                                <h5 className="card-title">
                                                  {plan.title}
                                                </h5>
                                                <p className="card-text">
                                                  {plan.status}
                                                </p>
                                                <h6 className="card-price">
                                                  {plan.price}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}

                                  <div className="text-center mt-4">
                                    {step > 1 && (
                                      <button
                                        className="btn btn-secondary mx-2"
                                        onClick={handlePreviousStep}
                                      >
                                        Anterior
                                      </button>
                                    )}

                                    {step < 4 && (
                                      <button
                                        className="btn btn-primary mx-2"
                                        onClick={handleNextStep}
                                      >
                                        Siguiente
                                      </button>
                                    )}

                                    {/* Mostrar el botón de "Registrar Vehículo" solo en el cuarto paso */}
                                    {step === 4 && (
                                      <button
                                        className="btn btn-success mx-2"
                                        onClick={handleRegisterVehicle}
                                        disabled={isSubmitting || isSubmitted} // Bloquea el botón si está enviando o ya fue enviado
                                      >
                                        {isSubmitting
                                          ? "Guardando..."
                                          : isSubmitted
                                          ? "Guardado"
                                          : "Guardar"}{" "}
                                        {/* Cambia el texto */}
                                      </button>
                                    )}
                                  </div>
                                </CardBody>
                              </Card>
                            </CardBody>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            {/* </div>
          </PerfectScrollbar>
        </div> */}
      </div>
    </div>
  );
}

export default CreateDetail;
